"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineSsaiManager = void 0;
var player_base_1 = require("@24i/player-base");
var BaseSsaiManager_1 = require("../BaseSsaiManager");
var TimelineSsaiManager = (function (_super) {
    __extends(TimelineSsaiManager, _super);
    function TimelineSsaiManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.events = [];
        return _this;
    }
    TimelineSsaiManager.prototype.canLoad = function (source, metadata) {
        var events = this.extractAdvertisementEvents(source, metadata);
        return events.length > 0;
    };
    TimelineSsaiManager.prototype.load = function (source, metadata) {
        this.events = this.extractAdvertisementEvents(source, metadata);
        return _super.prototype.load.call(this, source);
    };
    TimelineSsaiManager.prototype.setMetadata = function (sourceMetadata) {
        this.events = this.extractAdvertisementEvents(this.player.source, sourceMetadata);
        _super.prototype.setMetadata.call(this, sourceMetadata);
    };
    TimelineSsaiManager.prototype.unload = function () {
        this.events = [];
        _super.prototype.unload.call(this);
    };
    TimelineSsaiManager.prototype.getAdvertisements = function () {
        return this.events.flatMap(this.extractAdvertisement, this);
    };
    TimelineSsaiManager.prototype.extractAdvertisementEvents = function (source, sourceMetadata) {
        var _a, _b, _c, _d;
        var timeline = (_d = (_c = (_a = sourceMetadata === null || sourceMetadata === void 0 ? void 0 : sourceMetadata.timeline) !== null && _a !== void 0 ? _a : (_b = source.metadata) === null || _b === void 0 ? void 0 : _b.timeline) !== null && _c !== void 0 ? _c : source.timeline) !== null && _d !== void 0 ? _d : [];
        if (timeline.length === 0 || !this.player)
            return [];
        return timeline.filter(function (event) { return event.type === player_base_1.ISourceTimelineEventType.ADVERTISEMENT; });
    };
    TimelineSsaiManager.prototype.extractAdvertisement = function (event, adBreakIndex) {
        if (!this.player ||
            event.type !== player_base_1.ISourceTimelineEventType.ADVERTISEMENT)
            return null;
        var name = event.name, seekType = event.seekType, clickLink = event.clickLink;
        var start = event.start, end = event.end, skipOffset = event.skipOffset;
        var startUtc = this.getUtcTime(start, seekType);
        var endUtc = this.getUtcTime(end, seekType);
        var skipOffsetUtc = this.getUtcTime(skipOffset, seekType);
        start = this.getCurrentTime(start, seekType);
        end = this.getCurrentTime(end, seekType);
        skipOffset = this.getCurrentTime(skipOffset, seekType);
        return {
            type: player_base_1.ISourceTimelineEventType.ADVERTISEMENT,
            name: name,
            start: start,
            startUtc: startUtc,
            end: end,
            endUtc: endUtc,
            skipOffset: skipOffset,
            skipOffsetUtc: skipOffsetUtc,
            played: player_base_1.ITimelineEventPlayed.UNPLAYED,
            canSkip: false,
            canRestart: true,
            adBreak: {
                adBreakIndex: adBreakIndex,
                adBreakOffset: start,
                totalAds: 1,
            },
            ad: {
                adBreakIndex: adBreakIndex,
                adPosition: 0,
                skipOffset: skipOffset,
                duration: end - start,
                title: name !== null && name !== void 0 ? name : '',
                description: '',
                clickLink: clickLink,
                inStreamAdvertisement: true,
                canRestart: true,
            },
        };
    };
    return TimelineSsaiManager;
}(BaseSsaiManager_1.BaseSsaiManager));
exports.TimelineSsaiManager = TimelineSsaiManager;
//# sourceMappingURL=index.js.map